import { useAuth } from '@/lib/auth';

/**
 * Hook to safely check user roles with proper loading states
 * Prevents role-based view security issues by ensuring role is loaded before rendering
 */
export const useUserRole = () => {
  const { user, isLoading } = useAuth();
  
  return {
    isClient: user?.role === 'client',
    isVendor: user?.role === 'vendor',
    isAdmin: user?.role === 'admin',
    roleLoaded: !!user?.role,
    isLoading,
    role: user?.role,
  };
};
